import { render, staticRenderFns } from "./AcademicCalendar.vue?vue&type=template&id=36faf9e4&scoped=true"
import script from "./AcademicCalendar.vue?vue&type=script&lang=ts"
export * from "./AcademicCalendar.vue?vue&type=script&lang=ts"
import style0 from "./AcademicCalendar.vue?vue&type=style&index=0&id=36faf9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36faf9e4",
  null
  
)

export default component.exports